import { useContext, useMemo } from 'react';
import { Dropdown, ResponsiveMode } from '@fluentui/react';
import { useTranslation } from 'react-i18next';
import AppContext from 'App/AppContext';
import { getSelectableOrgUnitsForOutlook } from 'outlookComponents/orgUnitOutlook';

interface IOrgUnitPickerProps {
  disabled?: boolean;
}

const OrgUnitPicker = (props: IOrgUnitPickerProps) => {
  const { t } = useTranslation(['outlook']);
  const appContext = useContext(AppContext);

  const login = appContext.user.login;

  const options = useMemo(() => {
    return getSelectableOrgUnitsForOutlook(login).map((orgUnit) => ({ key: orgUnit.id, text: orgUnit.name }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [login.tenants, login.tenantId]);

  if (options.length < 2) {
    return null;
  }

  return (
    <Dropdown
      label={t('outlook:Task.OrgUnit')}
      options={options}
      selectedKey={login.tenantId}
      //keep the options in a regular callout: in the narrow task pane the Dropdown would otherwise
      //switch to its small-screen panel rendering (full-height list with an X).
      //This is why this picker still uses the Fluent Dropdown instead of IPDropdown: IPDropdownProps
      //is a hand-written interface (not extends IDropdownProps) and supports neither of these props.
      responsiveMode={ResponsiveMode.large}
      calloutProps={{ calloutMaxHeight: 300 }}
      onChange={(ev, option) => {
        if (option && option.key !== login.tenantId) {
          appContext.switchOrgUnit(option.key as string);
        }
      }}
      disabled={props.disabled || appContext.isAuthInProgress}
    />
  );
};

export default OrgUnitPicker;
